import { get } from 'lodash';
import { RecContentItemDto } from '../../apis/rec-gateway/rec-gateway.dtos';
import { CatalogExternalEntityDtoParsed } from '../../apis/sherpath-course-management-service/sherpath-course-management-service.dtos';
import { getExternalEntity, getExternalEntityClone } from '../../utilities/assignment-types-shared.utilities';
import { RecContentItemTitleHandlerProps, RecContentItemTitleHandlerPropsClone } from '../../models/assignment-types-shared.models';
import { AssignmentTypeStrategy } from '../model';
import { getExternalEntityCommon } from '../utils/common.utils';

// Falls back to the content item's own display name when the catalog has no external entity for it.
const getTitle = (contentItem: RecContentItemDto, externalEntity: CatalogExternalEntityDtoParsed): string | null => {
  const entityTitle: string = get(externalEntity, '_parsedData.title');
  return entityTitle || contentItem?.attributes?.displayName || null;
};

// MedEd Topic Overviews (catalog type TOPIC_OVERVIEW) are static, ungraded content resources.
// TODO(SHER-10879): title clicks are an empty link for now; add the launch behavior with the app-linking work.
export const topicOverview: AssignmentTypeStrategy = {
  coursePlanTitleClick: () => Promise.resolve(),
  recContentItemTitleHandler: (props: RecContentItemTitleHandlerProps) => {
    return getTitle(props.contentItem, getExternalEntity(props.contentItem, props.catalog));
  },
  recContentItemTitleHandlerClone: (props: RecContentItemTitleHandlerPropsClone) => {
    return getTitle(props.contentItem, getExternalEntityClone(props.contentItem, props.externalEntitiesMap));
  },
  getExternalEntity: getExternalEntityCommon,
  getExternalEntityClone: getExternalEntityCommon,
  isScorable: false
};
